import Platform from "../../../../libs/utility/Platform"
import { Theme } from "../../../components/constants" 

export default {
    loginForm:{
        display: "flex",
        flexDirection: "column",
        padding: "15px",
        width: "100%",
    },
    fieldMarginTop: {
        marginTop: "30px",
    },
    fullNameContainer: {
        display: "flex",
        flexDirection: Platform.isMobileView() ? "column" : "row",
        flexWrap: "wrap",
    },
    nameFieldsDiv: {
        flex: 1,
    },
    marginTopDependentField: {
        marginTop: "15px",
    },
    forgotPasswordDiv:{
        marginTop: "8px",
    },
    submitButtonDiv: {
        width: "100%",
        marginTop: "30px",
    },
    bottomLinkContainer: {
        display: "flex",
        flexDirection: "row",
        marginTop: "10px",
        fontSize: "14px",
    },
    separatorDiv: {
        marginTop: "100px",
    },
    signUpLink: {
        marginLeft: "6px",
    },
    errorMessage: {
        fontSize: "16px",
        lineHeight: "20px",
        color: Theme.ERROR_TEXT,
    },
    agreeTermsDiv: {
        display: "flex",
        flexDirection: "row",
        marginTop: "5px",
    },
    agreeTermsLink: {
        color: Theme.PRIMARY,
        textDecoration: "underline",
        marginLeft: "10px",
    },
    marketingCheckboxDiv:{
        marginTop: "5px",
    },
    disabledText: {
        padding: "10px",
        background: Theme.DISABLED_INPUT,
    },
    fieldDiv: {
        display: "flex",
        flexDirection: "column"
    },
    fieldLabel: {
        fontSize: "16px",
        lineHeight: "20px",
        color: Theme.DISABLED_TEXT,
    },
    phoneFieldDiv: {
        marginTop: "60px",
    },
    phoneNumberRow: {
        display: "flex",
        flexDirection: "row",
        gap: "10px",
    },
    phoneDivWError: {
        display: "flex",
        flexDirection: "column",
        flex: "1 1 0",
    },
    phoneNumberErrorDiv:{
        height: "23px",
    },
}